module.exports = __webpack_public_path__ + "img/jishi.64f8352a.png";